import React from 'react';
import Language from "@Components/Language";
import footerLogo from "@Assets/images/footer-logo.png";
import footerLogoWhite from "@Assets/images/footer-logo-white.png";

type FooterProps = { branding: string; whiteLinks?: boolean };

const COPYRIGHT_YEAR = new Date().getFullYear();

function EulaLink({ className }: { className?: string }) {
  return (
    <a href="/eula" className={className} target="_blank" rel="noopener noreferrer">
      {Language.get('EULA')}
    </a>
  );
}

export default function Footer(props: FooterProps) {
  const {branding, whiteLinks} = props;
  const isAlinta = branding === "ALINTA";
  const linkClass = whiteLinks ? 'text-white' : undefined;
  const logo = whiteLinks ? footerLogoWhite : footerLogo;
  return (
    <>
    {!isAlinta ? (
      <>
        <div className="flex align-items-center gap-2 white-space-nowrap relative" style={{ width: 'fit-content' }}>
          {Language.get('The JMS platform is brought to you by')}
          <img src={logo} alt="footer-logo" className="max-w-6rem absolute left-100 w-full ml-1" />
        </div>
        <span>
          &copy;{COPYRIGHT_YEAR}. {Language.get('All rights reserved')}  |
          {' '}
          <a href="/privacy-policy" className={linkClass} target="_blank" rel="noopener noreferrer">{Language.get('Privacy Policy')}</a>
          {'  |  '}
          <EulaLink className={linkClass} />
        </span>
      </>
    ) : (
      <div className="flex relative text-center w-full align-items-center justify-content-center flex-column md:flex-row">
        {import.meta.env.VITE_LOGIN_SCREEN_FOOTER_LOGO && (
          <img src={import.meta.env.VITE_LOGIN_SCREEN_FOOTER_LOGO
            &&  new URL(import.meta.env.VITE_LOGIN_SCREEN_FOOTER_LOGO, import.meta.url).href} alt="No Results" className="max-w-15rem mr-4 mobile-invert" />
        )}
        <>
          <span>&copy;{COPYRIGHT_YEAR}. {Language.get('Journey Management System. All rights reserved.')}</span>
          <span className="flex align-items-center gap-2 white-space-nowrap relative" style={{ width: 'fit-content' }}>
            &nbsp;{Language.get('An')}<img src={logo} alt="footer-logo" className="max-w-6rem w-full ml-1"/>{Language.get('Product.')}
            {' '}
            <EulaLink className={linkClass} />
          </span>
        </>
      </div>
    )}
    </>
  )
};
